import { useMutation, UseMutationOptions } from 'react-query';
import { JamaAPI } from 'api';

export const useAddRequestToJama = (config?: UseMutationOptions) => {
  return useMutation(JamaAPI.addRequestToJama, { ...config });
};
